// Application initialization - loaded on every page
// This module handles the main Quest application initialization sequence

// Get configuration from JSON config element
function loadConfig() {
  const configElement = document.getElementById('application-init-config');
  if (!configElement) {
    console.error('Application init configuration not found in DOM');
    return {};
  }

  try {
    return JSON.parse(configElement.textContent);
  } catch (e) {
    console.error('Failed to parse application init configuration:', e);
    return {};
  }
}

const config = loadConfig();
const SIDE_NAV_FIXED_BREAKPOINT = 1440;

// Note: All variables are referenced from window directly throughout this file
// because ERB templates set them after this module loads

function normalizeInitError(errorOrJqXHR, textStatus, errorThrown, context = {}) {
    const isErrorObject = errorOrJqXHR instanceof Error;
    const message =
        context.message ||
        (isErrorObject ? errorOrJqXHR.message : null) ||
        errorThrown ||
        textStatus ||
        errorOrJqXHR?.statusText ||
        errorOrJqXHR?.responseText ||
        String(errorOrJqXHR || 'Unknown error');

    return {
        message,
        error: errorOrJqXHR,
        data: {
            stage: context.stage,
            textStatus: textStatus || null,
            errorThrown: errorThrown || null,
            status: errorOrJqXHR?.status,
            response: errorOrJqXHR?.responseText?.substring?.(0, 300),
            stack: isErrorObject ? errorOrJqXHR.stack?.substring?.(0, 2000) : null
        }
    };
}

function reportInitError(prefix, errorOrJqXHR, textStatus, errorThrown, callPath, context = {}) {
    const normalized = normalizeInitError(errorOrJqXHR, textStatus, errorThrown, context);
    const msg = prefix + normalized.message;

    console.error(msg, normalized.error);

    if (typeof createBrowserevent === 'function') {
        createBrowserevent(msg, 1, normalized.data, callPath);
    }

    return normalized;
}

$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        }
    });

    $('[data-toggle="tooltip"]').tooltip();

    // Build template loading array based on template_path and role
    const templatePromises = [
        getTemplate(config.templates.controls),
        getTemplate(config.templates.quest)
    ];

    // Add nonstudent templates
    if (config.templatePath !== 'student' && config.templatePath !== 'external') {
        templatePromises.push(
            getTemplate(config.templates.search),
            getTemplate(config.templates.preview),
            getTemplate(config.templates.nonstudent),
            getTemplate(config.templates.presentation),
            getTemplate(config.templates.presentation_nonstudent),
            getTemplate(config.templates.presentation_classic)
        );
    }

    // Add admin templates
    if (config.isAdminPath) {
        templatePromises.push(getTemplate(config.templates.admin));
    }

    // Add role-specific template (skip for systemadmin - uses Vue3 only)
    if (config.templates.rolePath) {
        templatePromises.push(getTemplate(config.templates.rolePath));
    }

    return $.when(...templatePromises)
        .then(() => {

            if (window.controller !== 'welcome' && window.controller !== 'initial') {
                initNav();
                initBreadcrumbs();
                initHeaders();
            }

            initFooter();

            $('#user-bulletins-div').html($.templates('#user-bulletins-template').render({}));
        })
        .then(() => {
            return handleSetup();
        })
        .then(() => {
            // Accessibility: init tab keyboard navigation and announce page loaded
            if (typeof window.initTabAccessibility === 'function') {
                window.initTabAccessibility();
            }
            if (typeof window.srAnnounce === 'function') {
                window.srAnnounce('Page loaded');
            }
            var main = document.getElementById('main-content');
            if (main) { main.focus(); }
        })
        .then(() => {
            if (window.controller !== 'initial' && window.controller !== 'welcome') {
                return DisplayNotificationsLoop();
            }
        })
        .then(() => {
            if (window.controller === 'student' && typeof window.courseuser !== 'undefined' && window.courseuser != null) {
                return displayCourseusermessagesLoop(window.courseuser);
            }
        })
        .then(() => {
            // Initialization complete
        })
        .fail(function(errorOrJqXHR, textStatus, errorThrown) {
            reportInitError(
                'Quest page init failed: ',
                errorOrJqXHR,
                textStatus,
                errorThrown,
                'application-init'
            );
        });
});

function initFooter() {
    $('#quest-footer').html($.templates('#quest-footer-template').render({
        controller: window.controller,
    }));

    initDevFooter();
}

function initDevFooter() {
    if (!window.user || !window.user.view_dev_footer) {
        return;
    }

    var arr = [];

    return $.when(
        seedDevFooter({}, arr)
    ).then(() => {
        $('#quest-dev-footer').html($.templates('#quest-dev-footer-template').render({
            controller: window.controller,
            dev_footer: arr[0]
        }));
    }).fail(function(errorOrJqXHR, textStatus, errorThrown) {
        reportInitError(
            'Quest initDevFooter failed: ',
            errorOrJqXHR,
            textStatus,
            errorThrown,
            'application-init/initDevFooter'
        );
    });
}

function handleSetup() {
    let stage = 'setup';

    return $.when()
        .then(() => {
            if (typeof window.setup === 'function') {
                return window.setup();
            } else {
                return $('#target').html("");
            }
        })
        .then(() => {
            stage = 'handleTab';
            return handleTab();
        })
        .then(() => {
            stage = 'default_tab_0';
            if (!window.tab_0) {
                if (window.default_tab_0) {
                    $(window.default_tab_0).click();
                }
            }
        })
        .fail(function(errorOrJqXHR, textStatus, errorThrown) {
            reportInitError(
                'Quest handleSetup failed: ',
                errorOrJqXHR,
                textStatus,
                errorThrown,
                'application-init/handleSetup',
                { stage }
            );
        });
}

function handleTab() {
    return $.when()
        .then(() => {
            // tab_0 and tab_1 are set from ERB config
            window.tab_0 = config.tab0;
            window.tab_1 = config.tab1;

            if (!window.tab_0) {
                return;
            }

            // Inject quest-modern styles BEFORE clicking tabs
            // This ensures tabs have styling when they're first displayed
            if (window.injectQuestModernStyles) {
                window.injectQuestModernStyles();
            }

            return $.when(
                $(window.tab_0).click()
            ).then(() => {
                if (window.tab_1) {
                    setTimeout(() => {
                        $(window.tab_1).click();
                    }, 2000);
                }
            });
        });
}

function initHeaders() {
    if (window.template_path !== 'student') {
        if (typeof window.elementx !== 'undefined' && window.elementx) {
            window.initElementInfoHeader();
        }
    }

    if (window.template_path !== 'student' && window.action_name !== 'administer') {
        if (typeof window.course !== 'undefined' && window.course) {
            window.initCourseInfoHeader();
        }
    }
}

function initNav() {
    // Skip JSRender header for systemadmin - it uses Vue header instead
    if (window.controller === 'systemadmin') {
        return;
    }

    // Skip JSRender header for Vue3 UI pages
    if (window.use_vue3_ui) {
        return;
    }

    // #2452 Vue3 chrome flag: mount the 1:1 Vue port of the header/sidebar
    // (QuestHeader renders QuestSidebar itself when side_nav) instead of jsrender
    if (window.use_vue3_chrome) {
        window.mountQuestComponent('QuestHeader', '#quest-nav-header-div');
        return;
    }

    if (window.side_nav && !window.hideSideNav) {
        initDoubleNavHeader();
    } else {
        initSingleNavHeader();
    }
}

function initDoubleNavHeader() {
    $('#quest-nav-header-div').html($.templates("#quest-double-nav-header-template").render({
        controller: window.controller,
        is_systemadmin: window.is_systemadmin,
        is_institutionadmin: window.is_institutionadmin,
        is_learning_assistant: window.is_learning_assistant,
        is_limited_ta: window.is_limited_ta,
        is_ta: window.is_ta,
        is_editor: window.is_editor,
        user: window.user,
        is_instructor: window.is_instructor,
        masq_user: window.masq_user,
        side_nav: (window.side_nav && !window.hideSideNav),
        institution: window.institution
    }));

    $(".button-collapse").sideNav();
    initFixedSideNavToggle();
    var sideNavScrollbar = document.querySelector('.custom-scrollbar');
    var ps = new PerfectScrollbar(sideNavScrollbar);

    if (window.template_path === 'editor') {
        $('#left-box').html($.templates('#editor-leftbox-template').render({
            use_advanced_editor: window.use_advanced_editor,
            is_systemadmin: window.is_systemadmin
        }));
    }

    if (window.template_path === 'instructor') {
        window.initInstructorLeftBox();
    }

    $('.collapsible').collapsible();
}

function initSingleNavHeader() {
    $('#quest-nav-header-div').html($.templates("#quest-single-nav-header-template").render({
        controller: window.controller,
        is_systemadmin: window.is_systemadmin,
        is_institutionadmin: window.is_institutionadmin,
        is_learning_assistant: window.is_learning_assistant,
        is_limited_ta: window.is_limited_ta,
        is_ta: window.is_ta,
        is_editor: window.is_editor,
        user: window.user,
        is_instructor: window.is_instructor,
        masq_user: window.masq_user,
        institution: window.institution
    }));
}

function initFixedSideNavToggle() {
    if (window.template_path !== 'instructor') {
        return;
    }

    var button = document.querySelector('.button-collapse[data-activates]');
    var body = document.body;

    if (!button || !body || !body.classList.contains('fixed-sn')) {
        return;
    }

    body.classList.add('quest-side-nav-toggle-enabled');
    button.setAttribute('aria-controls', button.getAttribute('data-activates'));
    syncFixedSideNavToggleState(button);

    button.addEventListener('click', function (event) {
        if (window.innerWidth <= SIDE_NAV_FIXED_BREAKPOINT) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        var collapsed = body.classList.toggle('quest-side-nav-collapsed');
        button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }, true);

    window.addEventListener('resize', function () {
        syncFixedSideNavToggleState(button);
    });
}

function syncFixedSideNavToggleState(button) {
    var collapsed = document.body.classList.contains('quest-side-nav-collapsed');
    var expanded = window.innerWidth > SIDE_NAV_FIXED_BREAKPOINT && !collapsed;

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
}

function initBreadcrumbs() {
    // Skip breadcrumbs for Vue3 UI pages (they don't use breadcrumbs)
    if (window.use_vue3_ui) {
        return;
    }

    // #2452 Vue3 chrome renders its own breadcrumbs inside QuestHeader
    if (window.use_vue3_chrome) {
        return;
    }

    var template = '';
    switch (window.template_path) {
        case 'student':
            template = '#student-breadcrumbs-template';
            break;
        case 'editor':
            template = '#editor-breadcrumbs-template';
            break;
        case 'instructor':
            template = '#instructor-breadcrumbs-template';
            break;
        case 'systemadmin':
            return;
        case 'institutionadmin':
            template = '#' + window.template_path + '-breadcrumbs-template';
            break;
    }

    $('#breadcrumb-div').html($.templates(template).render({
        course: window.course,
        courseuser: window.courseuser,
        element: window.elementx,
        timeframe: window.timeframe,
        title: window.page_title,
        controller: window.controller,
        courseinstructor: window.courseinstructor,
        is_admin: (window.is_institutionadmin || window.is_systemadmin),
        institution: window.institution,
        instance: window.instance
    }));
}
